import 'ui-core/plugins/stickyElements/js/stickyElements';

(function (UX) {
    var observer = null,
        target = null;

    UX.stickyElements.selectors['header'] = '.pageHeader';

    if (UX.test.isIE()) {
        observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutationRecord) {
                if ($(mutationRecord.target).css('position') === 'absolute') {
                    $(mutationRecord.target).css('top', '0');
                }
            });
        });

        target = document.querySelector('.article-row-right');

        if (target) {
            observer.observe(target, {attributes: true, attributeFilter: ['style']});
        }
    }
})(UX);
